export const LOAD_CLAVESPRODUCTO_SUCCESS = 'LOAD_CLAVESPRODUCTO_SUCCESS';

export interface ClaveProductoState {
    clave: string
    descripcion: string
    descripcionMercancia:string
    uuidComprobante?: string
    peso?: number
}

interface ILoadClavesProducto {
    type: typeof LOAD_CLAVESPRODUCTO_SUCCESS
    clavesProducto: ClaveProductoState[]
}

export type ClaveProductoActionTypes = ILoadClavesProducto
